module.exports = __webpack_public_path__ + "9969d30982e819a9423cf8612c85b5b9.ttf";


//////////////////
// WEBPACK FOOTER
// ./css/fonts/ComicNeue/ComicNeue-Bold.ttf
// module id = 388
// module chunks = 0